import React from "react";

const ChatInput = ({value, onChange}) => {

    const handleChange = (e) => {
        onChange(e.target.value)
    }

    return (
        <input
        className="flex-1 border rounded-full px-4 py-2 text-sm bg-gray-50 focus:outline-none"
            id="chat-input"
            name="query"
            value={value}
            onChange={handleChange}
            placeholder="Enter your query or instructions here."
            required
            ></input>
    )
}

export default ChatInput